import { inject } from '@angular/core';
import { realmRoles, UserRole } from '@app/features/users/user.model';
import { IAuthenticatedUserService } from '@app/shared/auth/authenticated-user-service/authenticated-user-service';
import Keycloak from 'keycloak-js';

export class AuthenticatedUserService implements IAuthenticatedUserService {
  keycloak: Keycloak = inject(Keycloak);
  get displayName(): string | undefined {
    if (this.keycloak.tokenParsed) {
      if (this.keycloak.tokenParsed['name']) {
        return this.keycloak.tokenParsed['name'];
      } else {
        const firstName = this.keycloak.tokenParsed['given_name'] ?? '';
        const lastName = this.keycloak.tokenParsed['family_name'] ?? '';
        return `${firstName} ${lastName}`.trim();
      }
    }
    return undefined;
  }

  get userId(): string | undefined {
    return this.keycloak.tokenParsed?.sub;
  }

  get realmRoles(): UserRole[] {
    return (this.keycloak.realmAccess?.roles ?? []).filter((role) =>
      realmRoles.includes(role as UserRole),
    ) as UserRole[];
  }

  hasAnyRole(roles: UserRole[]): boolean {
    return roles.some((role) => this.realmRoles.includes(role));
  }
}
